// Shared blog post data with location tags
export interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  author: string;
  readTime: string;
  featured: boolean;
  hero?: boolean;
  slug: string;
  tags?: string[];
  location?: {
    states: string[]; // e.g. ['VIC', 'NSW', 'ALL']
    suburbs?: string[]; // e.g. ['Truganina', 'Tarneit']
  };
}

export const blogPosts: BlogPost[] = [
  {
    id: 201,
    title: 'Tutoring in Point Cook: a new Schoolola centre opens 13 July',
    excerpt: "Schoolola opens in Point Cook on Monday 13 July 2026. Victorian Curriculum tutoring for Prep to Year 8, including NAPLAN and selective entry preparation. Book a free assessment.",
    category: 'Company Updates',
    date: '2026-06-15',
    author: 'Schoolola Team',
    readTime: '4 min read',
    featured: true,
    slug: 'tutoring-in-point-cook-new-centre',
    tags: ['Point Cook', 'New Centre', 'Victoria', 'Launch'],
    location: { states: ['VIC'], suburbs: ['Point Cook'] }
  },
  {
    id: 301,
    title: 'Student first: why children learn better as participants, not passengers',
    excerpt: "Student first is Schoolola's first value. What treating children as active participants with agency looks like in tutoring, and how it protects your child's confidence.",
    category: 'Company Updates',
    date: '2026-07-22',
    author: 'Schoolola Team',
    readTime: '5 min read',
    featured: true,
    slug: 'student-first-what-it-means-at-schoolola',
    tags: ['Our values', 'Student first', 'Confidence', 'Parenting'],
    location: { states: ['ALL'] }
  },
  {
    id: 302,
    title: 'Joy back into learning: what tutoring looks like without shame or pressure',
    excerpt: "Joy back into learning is Schoolola's second value. Why we never shame, humiliate or pressure students, and how warmth, patience and gentle humour help reluctant learners.",
    category: 'Company Updates',
    date: '2026-07-22',
    author: 'Schoolola Team',
    readTime: '5 min read',
    featured: true,
    slug: 'joy-back-into-learning',
    tags: ['Our values', 'Reluctant learners', 'Confidence', 'Parenting'],
    location: { states: ['ALL'] }
  },
  {
    id: 303,
    title: 'Skills for life, not just exams: a journey, not a verdict',
    excerpt: "Skills for life, not just exams is Schoolola's third value. Why a result is a starting point rather than a verdict, and how growth-focused tutoring works alongside NAPLAN, selective entry and scholarship preparation.",
    category: 'Company Updates',
    date: '2026-07-22',
    author: 'Schoolola Team',
    readTime: '5 min read',
    featured: true,
    slug: 'skills-for-life-not-just-exams',
    tags: ['Our values', 'NAPLAN', 'Selective entry', 'Growth mindset'],
    location: { states: ['ALL'] }
  },
  {
    id: 304,
    title: "How to read your child's NAPLAN results: a parent guide",
    excerpt:
      'Understanding NAPLAN results: what Exceeding, Strong, Developing and Needs additional support mean, how to read each of the five domains, and the next steps that actually lift outcomes in Years 3, 5, 7 and 9.',
    category: 'Parent Guides',
    date: '2026-08-04',
    author: 'Schoolola Tutoring',
    readTime: '7 min read',
    featured: true,
    slug: 'how-to-read-naplan-results',
    tags: ['NAPLAN', 'Parent guide', 'Results', 'Literacy', 'Numeracy'],
    location: { states: ['ALL', 'NSW', 'VIC', 'WA'] }
  },
  // Parent Guides
  {
    id: 108,
    title: '7 Signs Your Child Might Be Using AI to Cheat on Homework',
    excerpt: 'From em dashes to vocabulary jumps, learn how to spot AI-generated homework. Discover the 7 key giveaways that your child may be using ChatGPT or AI tools to complete school assignments.',
    category: 'Parenting',
    date: '2026-03-12',
    author: 'Schoolola Tutoring',
    readTime: '6 min read',
    featured: true,
    hero: false,
    slug: 'signs-child-using-ai-cheat',
    tags: ['AI', 'Cheating', 'Homework', 'Parenting', 'ChatGPT', 'Academic Integrity'],
    location: { states: ['ALL'] }
  },
  // Exam Date Announcements
  {
    id: 106,
    title: 'NSW OC Test Dates 2026: 8-9 May - Complete Schedule & Preparation Guide',
    excerpt: 'Official 2026 NSW OC placement test dates confirmed: 8-9 May 2026. Complete timeline, application deadlines, test format, and expert preparation strategies for Year 4 students entering Opportunity Classes.',
    category: 'Education',
    date: '2026-02-21',
    author: 'Schoolola Team',
    readTime: '7 min read',
    featured: true,
    hero: false,
    slug: 'oc-test-dates-2026',
    tags: ['OC Test', 'Exam Dates', '2026', 'Year 4', 'Opportunity Class', 'NSW OC Test Preparation', 'OC Placement Test'],
    location: { states: ['NSW'] }
  },
  {
    id: 107,
    title: 'NSW Selective Test Dates 2026: 1-3 May - Complete Schedule & Preparation Guide',
    excerpt: 'Official 2026 NSW Selective High School Placement Test dates confirmed: 1-3 May 2026. Complete timeline, test format with 4 sections, and expert preparation strategies for Year 6 students seeking Year 7 entry.',
    category: 'Education',
    date: '2026-02-21',
    author: 'Schoolola Team',
    readTime: '8 min read',
    featured: true,
    hero: false,
    slug: 'selective-test-dates-2026',
    tags: ['Selective Test', 'Exam Dates', '2026', 'Year 6', 'Selective High School', 'NSW Selective Preparation', 'Year 7 Entry 2027'],
    location: { states: ['NSW'] }
  },
  // Featured Pathway Guides
  {
    id: 102,
    title: 'Complete NSW OC & Selective School Exam Pathway Guide 2025',
    excerpt: 'Comprehensive guide to NSW Opportunity Class (OC) and Selective School exam preparation. Learn about our proven TMRW strategy-based learning pathway from Year 3 to Year 6 for academic success.',
    category: 'Education',
    date: '2026-02-08',
    author: 'Schoolola Tutoring',
    readTime: '10 min read',
    featured: true,
    hero: true,
    slug: 'nsw-oc-selective-pathway-guide',
    tags: ['OC Test', 'Selective Schools', 'TMRW Methodology', 'Year 3-6', 'NSW Education', 'Exam Preparation'],
    location: { states: ['NSW'] }
  },
  {
    id: 103,
    title: 'Complete Victoria Scholarship & Selective School Exam Pathway Guide 2025',
    excerpt: 'Comprehensive guide to Victorian Scholarship (ACER & Edutest) and Selective School exam preparation. Learn about our proven TMRW strategy-based learning pathway from Year 4 to Year 8 for academic success.',
    category: 'Education',
    date: '2026-02-08',
    author: 'Schoolola Tutoring',
    readTime: '10 min read',
    featured: true,
    hero: false,
    slug: 'vic-scholarship-selective-pathway-guide',
    tags: ['Victorian Scholarship', 'Selective Schools', 'ACER', 'Edutest', 'TMRW Methodology', 'Year 4-8', 'VIC Education'],
    location: { states: ['VIC'] }
  },
  // Rankings posts
  {
    id: 100,
    title: '2025 NSW High School Rankings by HSC Results',
    excerpt: 'Complete 2025 NSW high school rankings based on HSC results. Compare selective schools, cutoff scores, and HSC performance data for 57 top schools.',
    category: 'Education',
    date: '2026-01-30',
    author: 'Schoolola Research Team',
    readTime: '5 min read',
    featured: true,
    hero: false,
    slug: '2025-high-school-rankings',
    tags: ['HSC', 'Rankings', 'Selective Schools', '2025'],
    location: { states: ['NSW'] }
  },
  {
    id: 101,
    title: 'NSW Selective School Rankings 2025 - Complete Guide',
    excerpt: 'Complete 2025 NSW Selective School Rankings. Compare fully selective and partially selective schools, HSC rankings, cutoff scores, and entry requirements.',
    category: 'Education',
    date: '2026-01-30',
    author: 'Schoolola Research Team',
    readTime: '6 min read',
    featured: true,
    hero: false,
    slug: 'nsw-selective-school-rankings-2025',
    tags: ['Selective Schools', 'Rankings', 'Cutoffs', '2025'],
    location: { states: ['NSW'] }
  },
  {
    id: 49,
    title: '2027 OC & Selective School Registration: Complete NSW Application Guide',
    excerpt: 'Applications open 6 November 2025 and close 20 February 2026. Complete guide to NSW OC and Selective High School registration including step-by-step instructions, eligibility criteria, and expert preparation tips.',
    category: 'Education',
    date: '2026-01-15',
    author: 'Schoolola Tutoring',
    readTime: '12 min read',
    featured: true,
    hero: false,
    slug: '2027-oc-selective-registration-guide',
    tags: ['OC Test', 'Selective Schools', 'Registration', '2027'],
    location: { states: ['NSW'] }
  },
  {
    id: 0,
    title: 'Why Children Love Video Games But Struggle With Homework',
    excerpt: 'Discover the psychological reasons why children can spend hours playing video games or watching TV but struggle to focus on homework for even a few minutes. Learn how understanding stimuli can help improve study habits.',
    category: 'Education',
    date: '2024-03-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: true,
    hero: false,
    slug: 'video-games-vs-homework-stimuli',
    location: { states: ['ALL'] }
  },
  {
    id: 47,
    title: 'How to Use the NSW Selective Score Calculator: A Parent\'s Guide',
    excerpt: 'Complete step-by-step guide for parents to use our free NSW Selective School Score Calculator. Learn how to interpret results, track progress, and plan your child\'s preparation journey.',
    category: 'Education',
    date: '2026-01-14',
    author: 'Schoolola Tutoring',
    readTime: '6 min read',
    featured: true,
    hero: false,
    slug: 'how-to-use-selective-calculator',
    tags: ['Calculator', 'Selective', 'Parent Guide'],
    location: { states: ['NSW'] }
  },
  {
    id: 48,
    title: 'How to Use the NSW OC Score Calculator: A Parent\'s Guide',
    excerpt: 'Complete step-by-step guide for parents to use our free NSW OC (Opportunity Class) Score Calculator. Learn how to calculate your child\'s OC placement score and plan their Year 5 preparation.',
    category: 'Education',
    date: '2026-01-14',
    author: 'Schoolola Tutoring',
    readTime: '6 min read',
    featured: true,
    hero: false,
    slug: 'how-to-use-oc-calculator',
    tags: ['Calculator', 'OC Test', 'Parent Guide'],
    location: { states: ['NSW'] }
  },
  {
    id: 1,
    title: 'NSW Selective School Score Calculator: Complete Guide 2025',
    excerpt: 'Use our free NSW Selective School Score Calculator to predict your child\'s chances. Learn how to calculate selective school scores, understand cutoffs, and maximise your preparation strategy for 2025 entry.',
    category: 'Education',
    date: '2025-01-15',
    author: 'Sarah Mitchell',
    readTime: '8 min read',
    featured: true,
    hero: false,
    slug: 'selective-score-calculator-guide',
    location: { states: ['NSW'] }
  },
  {
    id: 2,
    title: 'Victoria Selective Schools: Complete SEHS Guide 2025',
    excerpt: 'Everything you need to know about Selective Entry High Schools in Victoria. Learn about Melbourne High, Mac.Robertson, Nossal & Suzanne Cory High Schools, entrance exam preparation, and admission requirements.',
    category: 'Education',
    date: '2024-03-18',
    author: 'Dr Sriram Rajasekar',
    readTime: '12 min read',
    featured: true,
    hero: false,
    slug: 'victoria-selective-schools-guide',
    location: { states: ['VIC'] }
  },
  // Recent posts
  {
    id: 105,
    title: 'SCOPE™ Mass Exams & Competition - Caroline Springs, March 2026',
    excerpt: 'Schoolola Caroline Springs hosts FREE SCOPE™ practice exams across three Saturdays in March 2026: NAPLAN 3 & 5, Scholarship ACER Edutest, and Selective Entry. Win trophies and $500 cash prize.',
    category: 'Events',
    date: '2026-02-15',
    author: 'Schoolola Team',
    readTime: '5 min read',
    featured: true,
    hero: false,
    slug: 'scope-exam-caroline-springs-2026',
    tags: ['SCOPE', 'NAPLAN', 'Caroline Springs', 'Scholarship', 'Selective Entry', 'Practice Exam', 'Victoria'],
    location: { states: ['VIC'], suburbs: ['Caroline Springs'] }
  },
  {
    id: 104,
    title: 'SCOPE™ NAPLAN Practice Exam - Truganina, February 2026',
    excerpt: 'Schoolola Truganina hosts SCOPE™ NAPLAN 3 & 5 practice exams on 24-26 February 2026. Real exam conditions, expert marking, and personalised feedback.',
    category: 'Events',
    date: '2026-02-14',
    author: 'Schoolola Team',
    readTime: '4 min read',
    featured: true,
    hero: false,
    slug: 'scope-exam-truganina-naplan-2026',
    tags: ['SCOPE', 'NAPLAN', 'Truganina', 'Practice Exam', 'Victoria'],
    location: { states: ['VIC'], suburbs: ['Truganina'] }
  },
  {
    id: 46,
    title: 'Schoolola Opens New Truganina Learning Centre',
    excerpt: 'Continuing our Victorian expansion, we announce the opening of our second Melbourne centre in Truganina, bringing expert tutoring even closer to western suburbs families.',
    category: 'Company Updates',
    date: '2024-03-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '4 min read',
    featured: true,
    slug: 'schoolola-expands-truganina-centre',
    location: { states: ['VIC'], suburbs: ['Truganina'] }
  },
  {
    id: 47,
    title: 'Schoolola Expands to Victoria with New Tarneit Centre',
    excerpt: 'We are excited to announce our expansion into Victoria with the opening of our flagship Tarneit learning centre, bringing our proven teaching methods to more families across Australia.',
    category: 'Company Updates',
    date: '2024-03-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '3 min read',
    featured: true,
    slug: 'schoolola-expands-victoria-tarneit',
    location: { states: ['VIC'], suburbs: ['Tarneit'] }
  },
  {
    id: 3,
    title: 'Ultimate Guide to OC TMRW™ Test Preparation 2024',
    excerpt: 'Everything parents need to know about preparing their child for the Opportunity Class test, including study schedules, practice resources, and expert tips from our educators.',
    category: 'Education',
    date: '2024-03-08',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: true,
    slug: 'oc-tmrw-test-preparation-guide-2024',
    location: { states: ['NSW'] }
  },
  {
    id: 4,
    title: 'Selective TMRW™ School Entry: What Has Changed in 2024',
    excerpt: 'Recent updates to selective school admission criteria and how to adapt your preparation strategy accordingly for maximum success in the application process.',
    category: 'Education',
    date: '2024-03-06',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'selective-tmrw-school-changes-2024',
    location: { states: ['NSW'] }
  },
  {
    id: 6,
    title: 'Why Early Tutoring is Crucial in Today\'s Competitive World',
    excerpt: 'Understanding the importance of starting educational support early and how it impacts long-term academic success and confidence building.',
    category: 'Education',
    date: '2024-02-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '5 min read',
    featured: false,
    slug: 'why-early-tutoring-crucial',
    location: { states: ['ALL'] }
  },
  {
    id: 8,
    title: 'The Entrepreneurial Revolution: Why 9-5 Jobs Are No Longer Enough',
    excerpt: 'Exploring the shift towards entrepreneurship and how franchising opportunities like Schoolola are empowering individuals to build their own success.',
    category: 'Business',
    date: '2024-02-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'entrepreneurial-revolution-9-5-jobs',
    location: { states: ['ALL'] }
  },
  {
    id: 9,
    title: 'Why Franchising is the Smart Choice for Aspiring Entrepreneurs',
    excerpt: 'The benefits of choosing a proven franchise model over starting from scratch, with insights into the education sector\'s growth potential.',
    category: 'Business',
    date: '2024-02-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'franchising-smart-choice-entrepreneurs',
    location: { states: ['ALL'] }
  },
  {
    id: 10,
    title: 'The Importance of OC TMRW™ Preparation: Setting Your Child Up for Success',
    excerpt: 'Understanding why Opportunity Class preparation is more than just test prep - it\'s about building critical thinking and academic confidence.',
    category: 'Education',
    date: '2024-02-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'importance-oc-tmrw-preparation',
    location: { states: ['NSW'] }
  },
  {
    id: 11,
    title: 'Selective TMRW™ Schools: Your Gateway to Academic Excellence',
    excerpt: 'How selective school preparation through our TMRW™ programme opens doors to premium educational opportunities and future success.',
    category: 'Education',
    date: '2024-01-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'selective-tmrw-gateway-academic-excellence',
    location: { states: ['NSW'] }
  },
  {
    id: 12,
    title: 'Building Strong Foundations: The Key to Academic Success',
    excerpt: 'Why foundational learning in English and Mathematics is crucial for every student\'s educational journey and long-term achievement.',
    category: 'Education',
    date: '2024-01-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'building-strong-foundations-academic-success',
    location: { states: ['ALL'] }
  },
  {
    id: 13,
    title: 'Latest Trends in Educational Technology and Tutoring',
    excerpt: 'Exploring how artificial intelligence, adaptive learning, and personalized education are reshaping the tutoring landscape.',
    category: 'Education',
    date: '2024-01-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'latest-trends-educational-technology',
    location: { states: ['ALL'] }
  },
  {
    id: 14,
    title: 'The Impact of Quality Tutoring on Student Confidence',
    excerpt: 'Research-backed insights into how professional tutoring support transforms not just grades, but self-belief and motivation.',
    category: 'Education',
    date: '2024-01-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '5 min read',
    featured: false,
    slug: 'impact-quality-tutoring-student-confidence',
    location: { states: ['ALL'] }
  },
  {
    id: 16,
    title: 'Mathematics Mastery: Beyond Basic Arithmetic',
    excerpt: 'Advanced mathematical concepts every primary school student should master, with practical exercises and parent guidance.',
    category: 'Education',
    date: '2024-01-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'mathematics-mastery-beyond-arithmetic',
    location: { states: ['ALL'] }
  },
  {
    id: 18,
    title: 'The Future of Work: Preparing Children for Tomorrow\'s Careers',
    excerpt: 'Understanding how rapid technological change is reshaping career prospects and what skills children need to develop.',
    category: 'Education',
    date: '2023-12-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'future-work-preparing-children-careers',
    location: { states: ['ALL'] }
  },
  {
    id: 19,
    title: 'Franchising Success Stories: From Corporate to Education Entrepreneur',
    excerpt: 'Real stories of professionals who left corporate careers to build successful education franchises and found greater fulfillment.',
    category: 'Business',
    date: '2023-12-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'franchising-success-corporate-education',
    location: { states: ['ALL'] }
  },
  {
    id: 20,
    title: 'Holiday Learning: Making the Most of School Breaks',
    excerpt: 'How structured holiday programmes can prevent learning loss and accelerate academic progress during school breaks.',
    category: 'Education',
    date: '2023-12-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '5 min read',
    featured: false,
    slug: 'holiday-learning-school-breaks',
    location: { states: ['ALL'] }
  },
  {
    id: 21,
    title: 'OC TMRW™ vs Regular Tutoring: Understanding the Difference',
    excerpt: 'What makes our trademarked TMRW™ methodology unique and why it delivers superior results for Opportunity Class preparation.',
    category: 'Education',
    date: '2023-11-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'oc-tmrw-vs-regular-tutoring',
    location: { states: ['NSW'] }
  },
  {
    id: 22,
    title: 'The Economic Benefits of Educational Franchising',
    excerpt: 'Analyzing the financial advantages and market stability of investing in education sector franchises in Australia.',
    category: 'Business',
    date: '2023-11-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'economic-benefits-educational-franchising',
    location: { states: ['ALL'] }
  },
  {
    id: 24,
    title: 'Why Traditional Employment is Becoming Obsolete',
    excerpt: 'The shift from job security to skill security and how entrepreneurship offers better long-term financial stability.',
    category: 'Business',
    date: '2023-11-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'traditional-employment-becoming-obsolete',
    location: { states: ['ALL'] }
  },
  {
    id: 25,
    title: 'Selective TMRW™: The Science Behind Our Success',
    excerpt: 'Understanding the research-based methodologies that make our Selective TMRW™ programme the most effective preparation system.',
    category: 'Education',
    date: '2023-11-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'selective-tmrw-science-behind-success',
    location: { states: ['NSW'] }
  },
  {
    id: 26,
    title: 'Foundation Skills: The Building Blocks of Academic Excellence',
    excerpt: 'Why strong foundational skills in literacy and numeracy are essential for success in advanced programmes like OC TMRW™ and Selective TMRW™.',
    category: 'Education',
    date: '2023-11-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'foundation-skills-building-blocks',
    location: { states: ['NSW'] }
  },
  {
    id: 27,
    title: 'The Tutoring Industry Boom: Trends and Opportunities',
    excerpt: 'Market analysis of Australia\'s growing tutoring sector and what it means for students, parents, and potential franchise owners.',
    category: 'Business',
    date: '2023-10-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'tutoring-industry-boom-trends',
    location: { states: ['ALL'] }
  },
  {
    id: 28,
    title: 'Early Intervention: Why Starting Tutoring in Primary School Matters',
    excerpt: 'The critical importance of identifying and addressing learning gaps early, before they become major obstacles to academic success.',
    category: 'Education',
    date: '2023-10-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'early-intervention-primary-school',
    location: { states: ['ALL'] }
  },
  {
    id: 29,
    title: 'Technology Integration in Modern Tutoring',
    excerpt: 'How Schoolola integrates cutting-edge technology with traditional teaching methods to maximise learning outcomes.',
    category: 'Education',
    date: '2023-10-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'technology-integration-modern-tutoring',
    location: { states: ['ALL'] }
  },
  {
    id: 30,
    title: 'From Employee to Entrepreneur: The Franchise Journey',
    excerpt: 'A comprehensive guide to transitioning from traditional employment to franchise ownership, with real-world examples and practical advice.',
    category: 'Business',
    date: '2023-10-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '10 min read',
    featured: false,
    slug: 'employee-entrepreneur-franchise-journey',
    location: { states: ['ALL'] }
  },
  {
    id: 31,
    title: 'The Psychology of Learning: Understanding Your Child\'s Mind',
    excerpt: 'Insights into how children learn best and how to create optimal conditions for academic growth and personal development.',
    category: 'Education',
    date: '2023-10-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'psychology-learning-understanding-child',
    location: { states: ['ALL'] }
  },
  {
    id: 33,
    title: 'Investment Opportunities in Educational Services',
    excerpt: 'Why investing in education franchises offers both financial returns and social impact, making it an ideal business opportunity.',
    category: 'Business',
    date: '2023-09-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'investment-opportunities-educational-services',
    location: { states: ['ALL'] }
  },
  {
    id: 34,
    title: 'Personalized Learning: The Future of Education',
    excerpt: 'How adaptive learning technologies and personalized instruction are revolutionizing the way students learn and achieve success.',
    category: 'Education',
    date: '2023-09-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'personalized-learning-future-education',
    location: { states: ['ALL'] }
  },
  {
    id: 35,
    title: 'The Gig Economy and Education: New Models of Success',
    excerpt: 'Exploring how the gig economy principles apply to education and create new opportunities for both educators and entrepreneurs.',
    category: 'Business',
    date: '2023-09-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'gig-economy-education-success-models',
    location: { states: ['ALL'] }
  },
  {
    id: 36,
    title: 'Critical Thinking Skills: Beyond Test Preparation',
    excerpt: 'How programmes like OC TMRW™ and Selective TMRW™ develop essential critical thinking skills that benefit students throughout life.',
    category: 'Education',
    date: '2023-09-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'critical-thinking-beyond-test-prep',
    location: { states: ['NSW'] }
  },
  {
    id: 37,
    title: 'The Rise of EdTech Startups and What It Means for Traditional Tutoring',
    excerpt: 'Analyzing the impact of educational technology startups on traditional tutoring models and how established providers are adapting.',
    category: 'Business',
    date: '2023-09-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'rise-edtech-startups-traditional-tutoring',
    location: { states: ['ALL'] }
  },
  {
    id: 38,
    title: 'Foundations Programme: Building Confidence Through Competence',
    excerpt: 'How our Foundations programme in English and Mathematics builds not just skills, but the confidence students need to tackle advanced challenges.',
    category: 'Education',
    date: '2023-09-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'foundations-programme-building-confidence',
    location: { states: ['ALL'] }
  },
  {
    id: 39,
    title: 'The Entrepreneurial Mindset: Teaching Kids to Think Like Innovators',
    excerpt: 'How hands-on, project-based learning instils entrepreneurial thinking and innovation skills from an early age.',
    category: 'Education',
    date: '2023-08-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'entrepreneurial-mindset-kids-innovators',
    location: { states: ['ALL'] }
  },
  {
    id: 40,
    title: 'Financial Freedom Through Franchise Ownership',
    excerpt: 'Real-world examples of how education franchise ownership has provided financial independence and career satisfaction for investors.',
    category: 'Business',
    date: '2023-08-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'financial-freedom-franchise-ownership',
    location: { states: ['ALL'] }
  },
  {
    id: 41,
    title: 'The Science of Memory: How Students Learn and Retain Information',
    excerpt: 'Understanding cognitive science principles that inform our teaching methodologies and help students achieve better learning outcomes.',
    category: 'Education',
    date: '2023-08-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'science-memory-students-learn-retain',
    location: { states: ['ALL'] }
  },
  {
    id: 42,
    title: 'Digital Literacy in the Age of AI',
    excerpt: 'Why digital literacy and understanding of artificial intelligence are becoming as fundamental as traditional literacy skills.',
    category: 'Education',
    date: '2023-08-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'digital-literacy-age-ai',
    location: { states: ['ALL'] }
  },
  {
    id: 43,
    title: 'Breaking Free from Corporate Constraints: The Franchise Alternative',
    excerpt: 'How franchise ownership offers the benefits of business ownership without the risks of starting completely from scratch.',
    category: 'Business',
    date: '2023-08-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'breaking-free-corporate-franchise-alternative',
    location: { states: ['ALL'] }
  },
  {
    id: 44,
    title: 'Study Skills That Last a Lifetime',
    excerpt: 'Essential study techniques and learning strategies that our programmes teach students to use throughout their academic and professional careers.',
    category: 'Education',
    date: '2023-08-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'study-skills-last-lifetime',
    location: { states: ['ALL'] }
  },
  {
    id: 45,
    title: 'The Economics of Education: Why Investment in Learning Pays Off',
    excerpt: 'Statistical analysis of how quality education and tutoring investment correlates with long-term academic and career success.',
    category: 'Education',
    date: '2023-07-30',
    author: 'Dr Sriram Rajasekar',
    readTime: '10 min read',
    featured: false,
    slug: 'economics-education-investment-learning',
    location: { states: ['ALL'] }
  },
  {
    id: 46,
    title: 'Scaling Your Impact: From Teacher to Education Entrepreneur',
    excerpt: 'How passionate educators are leveraging franchise opportunities to expand their impact beyond individual classrooms.',
    category: 'Business',
    date: '2023-07-25',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'scaling-impact-teacher-education-entrepreneur',
    location: { states: ['ALL'] }
  },
  {
    id: 47,
    title: 'The Multi-Sensory Learning Revolution',
    excerpt: 'How incorporating visual, auditory, and kinesthetic learning approaches enhances student comprehension and retention.',
    category: 'Education',
    date: '2023-07-20',
    author: 'Dr Sriram Rajasekar',
    readTime: '6 min read',
    featured: false,
    slug: 'multi-sensory-learning-revolution',
    location: { states: ['ALL'] }
  },
  {
    id: 48,
    title: 'Creating Passive Income Through Educational Services',
    excerpt: 'How franchise ownership in the education sector can generate sustainable, passive income streams while making a positive social impact.',
    category: 'Business',
    date: '2023-07-15',
    author: 'Dr Sriram Rajasekar',
    readTime: '8 min read',
    featured: false,
    slug: 'creating-passive-income-educational-services',
    location: { states: ['ALL'] }
  },
  {
    id: 49,
    title: 'The Global Competitiveness Factor: Preparing Australian Students',
    excerpt: 'How programmes like OC TMRW™ and Selective TMRW™ prepare Australian students to compete on the global stage.',
    category: 'Education',
    date: '2023-07-10',
    author: 'Dr Sriram Rajasekar',
    readTime: '9 min read',
    featured: false,
    slug: 'global-competitiveness-australian-students',
    location: { states: ['ALL'] }
  },
  {
    id: 50,
    title: 'From Startup Risk to Franchise Stability',
    excerpt: 'Comparing the risks and benefits of starting an independent business versus investing in a proven franchise system.',
    category: 'Business',
    date: '2023-07-05',
    author: 'Dr Sriram Rajasekar',
    readTime: '7 min read',
    featured: false,
    slug: 'startup-risk-franchise-stability',
    location: { states: ['ALL'] }
  }
];

/** Slugs that use /blog/ prefix instead of /newsroom/ */
const blogPrefixSlugs = [
  'victoria-selective-schools-guide', 'schoolola-expands-victoria-tarneit',
  'schoolola-expands-truganina-centre', 'video-games-vs-homework-stimuli',
  'scope-exam-truganina-naplan-2026',
  'scope-exam-caroline-springs-2026', 'oc-test-preparation-2024',
  'oc-mathematics-section', 'oc-general-ability', 'oc-time-management',
  'oc-common-mistakes', 'oc-vs-selective',
  'tutoring-in-point-cook-new-centre',
  'student-first-what-it-means-at-schoolola', 'joy-back-into-learning',
  'skills-for-life-not-just-exams', 'how-to-read-naplan-results',
];

/** Returns the correct URL path for a blog post */
export const getPostUrl = (slug: string): string => {
  return blogPrefixSlugs.includes(slug) ? `/blog/${slug}` : `/newsroom/${slug}`;
};

/** Filter posts relevant to a given state code */
export const getPostsForState = (stateCode: string, limit?: number): BlogPost[] => {
  const filtered = blogPosts
    .filter(post => {
      if (!post.location) return true; // no location = show everywhere
      return post.location.states.includes(stateCode) || post.location.states.includes('ALL');
    })
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  return limit ? filtered.slice(0, limit) : filtered;
};
